module.exports = __webpack_public_path__ + "img/img_charge1.5811fd8c.png";